module.exports = __webpack_public_path__ + "static/images/certification.dca5027.png";